import Vue from 'vue'

const client = Vue.prototype.$api

export default {
  getHealthServicesByUserId (userId) {
    return client.get('healthServices/getHealthServicesByUserId', { params: {userId: userId} })
  },
  getProfHealthServicesByNameAndCity (name, cityId) {
    return client.get('healthServices/getProfHealthServicesByNameAndCity', { params: {name: name, cityId: cityId} })
  },
  getCenterHealthServicesByNameAndCity (name, cityId) {
    return client.get('healthServices/getCenterHealthServicesByNameAndCity', { params: {name: name, cityId: cityId} })
  },
  getCenterAndProfHealthServicesByNameAndCity (name, cityId) {
    return client.get('healthServices/getCenterAndProfHealthServicesByNameAndCity', { params: {name: name, cityId: cityId} })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/HealthServicesRepository.js